import classNames from "classnames";
import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select, { components } from "react-select";
import { Label } from "reactstrap";
import { truncateFileName } from "src/utils/common";

const FormSelect = ({
  label,
  name,
  placeholder,
  classInput,
  classGroup,
  options,
  control,
  defaultValue = null,
  errors,
  required,
  requiredMessage,
  onChangeExtra,
  indexMenu = 1051,
  disabled,
  isSearchable = false,
  isClearable = false,
  isLoading = false,
  closeMenuOnSelect = true,
  shouldDirty = true,
  isMulti = false,
  maxLengthOption = null,
  noOptionsMessage = "No options",
  setValue = null,
}) => {
  const { t } = useTranslation("common");

  const calculateMaxLength = () => {
    if (maxLengthOption) return maxLengthOption;

    const selectElement = document.querySelector(`[name="${name}"]`);
    if (selectElement) {
      const selectWidth = selectElement.offsetWidth;
      const availableWidth = selectWidth - 40;
      return Math.floor(availableWidth / 8);
    }

    return 20;
  };

  const Option = (props) => {
    const { data, children } = props;
    // const dynamicMaxLength = calculateMaxLength();
    // const truncatedLabel = truncateFileName(data.label || children, dynamicMaxLength);

    return (
      <components.Option {...props}>
        {data.label}
      </components.Option>
    );
  };

  const MenuList = (props) => {
    useEffect(() => {
      const currentOption = options?.find((c) => c.value === props.selectProps?.value?.value);
      const currentOptionIndex = props.options?.map((o) => o.value)?.indexOf(currentOption?.value);
      if (currentOptionIndex >= 0) {
        const option = props.children.find((child) => child.props && child.props.isSelected);
        const optionElement = document?.getElementById(option?.props?.innerProps?.id);

        if (optionElement) {
          optionElement?.scrollIntoView?.({ block: "nearest" });
        }
      }
    }, [props.selectProps?.value?.value]);
    return <components.MenuList {...props} />;
  };

  const getValueSelected = (val) => {
    const optionByVal = {};
    options?.forEach((opt) => {
      optionByVal[opt.value] = opt;
    });
    if (!isMulti) {
      return optionByVal[val] || "";
    }
    return val?.length ? val.map((v) => optionByVal[v]) : [];
  };

  return (
    <div className={classNames("form-group position-relative", classGroup)} name={name}>
      {label && (
        <Label for={name} className={classNames("position-relative", { "required-input": required })}>
          {label}
        </Label>
      )}

      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        rules={{
          ...(required && { required: requiredMessage || t("required") }),
        }}
        render={({ field: { onChange, value, ref } }) => (
          <Select
            inputRef={ref}
            name={name}
            value={getValueSelected(value)}
            onChange={(val) => {
              let selectVal = null;
              if (val) {
                selectVal = isMulti ? val.map((v) => v.value) : val.value;
              }
              if (setValue) {
                setValue(name, selectVal, { shouldDirty: shouldDirty });
              } else {
                onChange(selectVal); // Updates react-hook-form
              }
              if (onChangeExtra) onChangeExtra(selectVal); // Additional handler for external logic
            }}
            isDisabled={disabled}
            options={options}
            placeholder={placeholder}
            className={classNames(classInput)}
            menuPortalTarget={document.body}
            components={{ MenuList, Option }}
            noOptionsMessage={() => noOptionsMessage}
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                borderColor: errors ? "#ff5c75" : "#ced4da",
                paddingLeft: "calc(0.9rem - 8px)",
              }),
              placeholder: (defaultStyles) => ({
                ...defaultStyles,
                color: "#adb5bd",
              }),
              menuPortal: (base) => ({ ...base, zIndex: indexMenu }),
            }}
            isSearchable={isSearchable}
            isClearable={isClearable}
            isLoading={isLoading}
            filterOption={(option, inputValue) =>
              option.label.toLowerCase().includes(inputValue.toLowerCase())
            }
          />
        )}
      />

      {errors && <div className="text-danger font-12 position-absolute">{errors}</div>}
    </div>
  );
};

export default FormSelect;
